import React, { Component } from "react";
import { isAppInitialized } from '@app/utils/loading.utils';

interface LoaderProps {
  fullScreen?: boolean;
  ignoreInitState?: boolean;
}

class Loader extends Component<LoaderProps> {
  shouldComponentUpdate() {
    // Don't re-render this component once mounted
    return false;
  }

  render() {
    const { fullScreen = false, ignoreInitState = false } = this.props;

    // make the loader less intrusive
    const appReady = isAppInitialized() && !ignoreInitState;
    const opacity = appReady ? 0.7 : 0.9;
    const zIndex = appReady ? 1000 : 9999;

    return (
      <>
        <style>
          {`
            @keyframes l10 {
              0% { background-position: 0 0, 0 100%, 100% 100%; }
              25% { background-position: 100% 0, 0 100%, 100% 100%; }
              50% { background-position: 100% 0, 0 0, 100% 100%; }
              75% { background-position: 100% 0, 0 0, 0 100%; }
              100% { background-position: 100% 100%, 0 0, 0 100%; }
            }
          `}
        </style>
        <div className="loader-wrapper" style={{ 
          zIndex,
          position: fullScreen ? 'fixed' : 'absolute',
          width: '100%',
          height: '100%',
          top: 0,
          left: 0,
          backgroundColor: `rgba(255, 255, 255, ${opacity})`
        }}>
          <div className="loader-content">
            <div className="m-auto mt-2" style={{
              width: '65px',
              aspectRatio: '1',
              background: `radial-gradient(farthest-side,var(--branding-color, #85ba3b) calc(95% - 3px),transparent calc(100% - 3px) 98%,transparent 101%) no-repeat, radial-gradient(farthest-side,var(--branding-color, #85ba3b) calc(95% - 3px),transparent calc(100% - 3px) 98%,transparent 101%) no-repeat, radial-gradient(farthest-side,var(--branding-color, #85ba3b) calc(95% - 3px),transparent calc(100% - 3px) 98%,transparent 101%) no-repeat`,
              backgroundSize: '30px 30px',
              animation: 'l10 1.5s infinite'
            }}></div>
          </div>
        </div>
      </>
    );
  }
}

export default Loader;